export {default} from './Welcome';



// WEBPACK FOOTER //
// ./src/pages/Welcome/index.ts